// extracted by mini-css-extract-plugin
module.exports = {"container":"Integrations_container__ESt6W","hero":"Integrations_hero__MsmZQ","sidebar":"Integrations_sidebar__fn_3W","content":"Integrations_content__pjbcE"};